<template>
    <form @submit.prevent="store" class="form-signin">
        <h1 class="h3 mb-3 font-weight-normal">{{ $t('Регистрация') }}</h1>

        <div class="form-group">
            <label for="inputName">{{ $t('Имя') }}</label>
            <input type="text"
                    id="inputName"
                    :class="{'form-control': true, 'is-invalid mb-1': hasError('name')}"
                    :placeholder="$t('Имя')"
                    required
                    v-model="form.name"
                    autofocus />
        </div>
        <span class="invalid-feedback d-block" v-if="hasError('name')" v-text="getError('name')"></span>

        <div class="form-group">
            <label for="inputEmail">{{ $t('Email') }}</label>
            <input type="email"
                    id="inputEmail"
                    :class="{'form-control': true, 'is-invalid mb-1': hasError('email')}"
                    :placeholder="$t('Email')"
                    required
                    v-model="form.email"
                    autofocus />
        </div>
        <span class="invalid-feedback d-block" v-if="hasError('email')" v-text="getError('email')"></span>

        <div class="form-group">
            <label for="inputPassword" class="sr-only">{{ $t('Пароль') }}</label>
            <input type="password"
                    id="inputPassword"
                    :class="{'form-control': true, 'is-invalid mb-1': hasError('password')}"
                    :placeholder="$t('Пароль')"
                    v-model="form.password"
                    required />
        </div>
        <span class="invalid-feedback d-block" v-if="hasError('password')" v-text="getError('password')"></span>

        <div class="form-group">
            <label for="inputPasswordConfirmation" class="sr-only">{{ $t('Повторите пароль') }}</label>
            <input type="password"
                    id="inputPasswordConfirmation"
                    class="form-control"
                    :placeholder="$t('Повторите пароль')"
                    v-model="form.password_confirmation"
                    required />
        </div>

        <button class="btn btn-blue" type="submit">{{ $t('Далее') }}</button>

        <router-link to="/login" class="btn btn-link text-center w-100 mt-2">{{ $t('У меня есть аккаунт') }}</router-link>
    </form>
</template>

<script>
import { EventBus } from '@/event-bus.js';

export default {
    name: "Register",

    data: function() {
        return {
            form: {
                name: null,
                email: null,
                password: null,
                password_confirmation: null,
            },

            errors: {},
        };
    },

    watch: {
        'form.name': function() {
            delete this.errors['name'];
        },
        'form.email': function() {
            delete this.errors['email'];
        },
        'form.password': function() {
            delete this.errors['password'];
        }
    },


    methods: {
        store() {
            axios.post(`/auth/register`, this.form)
                .then(({data}) => {
                    const token = data.data.token;

                    const user = data.data.user;

                    localStorage.setItem('token', token);

                    axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;

                    this.$store.commit('auth_success', token, user);

                    this.$ga.event({
                        eventCategory: "registrationButton",
                        eventAction: "successRegistration",
                        eventLabel: "New User",
                    });

                    EventBus.$emit('show-alert', data.message, 'success');

                    setTimeout(() => {
                        location.href = '/';
                    }, 1000);
                }).catch(({response}) => {
                    console.log(response);

                    this.$ga.event({
                        eventCategory: "registrationButton",
                        eventAction: "errorRegistration",
                    });
                    
                    if(response.status !== 422) {
                        return EventBus.$emit('show-alert', response.data.message ? response.data.message : "Неизвестная ошибка", 'error');   
                    }

                    this.errors = response.data.data;
                });
        },

        hasError(name) {
            return this.errors[name] !== undefined;
        },
        
        getError(name) {
            if(this.hasError(name)) {
                return this.errors[name][0].replace(name, '');
            }

            return "";
        },
    }
};
</script>

<style scoped lang="scss">

</style>